module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "sketch"
  }, [_c('g', {
    staticClass: "configure",
    attrs: {
      "name": _vm.rootName
    }
  }, [_c('rect', {
    staticClass: "background"
  }), _vm._v(" "), _c('circle', {
    staticClass: "pictureOut"
  }), _vm._v(" "), _c('circle', {
    staticClass: "pictureIn"
  }), _vm._v(" "), _c('Toolbox'), _vm._v(" "), _c('Tag', {
    attrs: {
      "data": "FinalState"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f643a82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stateEnd.vue
// module id = 56
// module chunks = 0